import { PdfHeader } from "../../../../components";
import dayjs from "dayjs";
import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";

const AllCustomerReport = ({ data, fromDate, toDate, selectedMonth, selectedMonthString }) => {
    return <div className="customer-report">
        <div className="report-container" style={{ padding: 0, margin: 0 }}>
            <PdfHeader pdfName="Customer's Report" />
            <div className="total-details flexible">
                {
                    (fromDate && toDate) &&<div>
                    <h4 className="information-title">Date</h4>
                    <p style={{ margin: 0, padding: "10px 0px" }}>{fromDate && toDate ? `${dayjs(fromDate).format("DD-MM-YYYY")} to ${dayjs(toDate).format("DD-MM-YYYY")}` : "-"}</p>
                </div>
                }
                {
                    selectedMonth && <div>
                        <h4 className="information-title">Month</h4>
                        <p style={{ margin: 0, padding: "10px 0px" }}>{dayjs(selectedMonth).format("MMMM YYYY")}</p>
                    </div>
                }
                
                <div>
                    <h3 className="information-title">Customer's</h3>
                    <h2 className="information-detail">{data?.length}</h2>
                </div>
            </div>
            <table className="report-table">
                <thead>
                    <tr>
                        <th colSpan={1}>SNo</th>
                        <th colSpan={3}>Date</th>
                        <th colSpan={5}>Customer Name /Custo ID</th>
                        <th colSpan={5}>Contact Info</th>
                        <th colSpan={2}>Total Cons.</th>
                        <th colSpan={2}>Upcoming Cons.</th>
                        <th colSpan={2}>Cancelled Cons.</th>
                        <th colSpan={3}>My Balance</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((detail, index) => (
                        <tr key={detail?.id}>
                            <td colSpan={1}>{index + 1}</td>
                            <td colSpan={3}>{detail?.date ? dayjs(detail?.date).format("DD-MM-YYYY") : "Nil"}</td>
                            <td colSpan={5}>
                                {detail?.firstName || "Nil"} {detail?.middleName || ""} {detail?.lastName || ""}
                                <br />
                                <small>{detail?.customerNo || "Nil"}</small>
                            </td>
                            <td colSpan={5}>
                                {detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}
                                <br />
                                <small>{detail?.email || "Nil"}</small>
                            </td>
                            <td colSpan={2}>{detail?.totalConsultation || "Nil"}</td>
                            <td colSpan={2}>{detail?.upcomingConsultation || "Nil"}</td>
                            <td colSpan={2}>{detail?.totalCancelConsultation || "Nil"}</td>
                            <td colSpan={3}>&#8377; {formatAmount(detail?.myBalance || 0)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
}
export default AllCustomerReport